import {
  CreateSalaryRecordsParams,
  NotSupportAnotherParamsTypes,
  SalaryCategoryDataTypes,
  SalaryCategoryParamsTypes,
  SalaryRecordsDataTypes
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllSalaryRecordsService = async (
  params?: BaseFilterParams & { _payrollPeriodId: string },
): Promise<SalaryRecordsDataTypes[]> => {
  const res = await axiosInstance.get('salary-records', { params });
  return res.data.data;
};

export const createSalaryRecordsService = async (
  params: CreateSalaryRecordsParams,
): Promise<{ id: number, salaryWarning: boolean, salaryWarningYear: boolean }> => {
  const res = await axiosInstance.post('salary-records', params);
  return res.data.data;
};

export const getSalaryCatetoryService = async (
  params?: BaseFilterParams & { _payrollPeriodId: string },
): Promise<SalaryCategoryDataTypes[]> => {
  const res = await axiosInstance.get('salary-categories', { params });
  return res.data.data;
};

export const createSalaryCatetoryService = async (
  params: SalaryCategoryParamsTypes,
): Promise<void> => {
  const res = await axiosInstance.post('salary-categories', params);
  return res.data;
};

export const addNoteSupportAnotherService = async (
  id: string,
  params: NotSupportAnotherParamsTypes,
): Promise<void> => {
  const res = await axiosInstance.post(`salary-records/${id}/add-note-support-another`, params);
  return res.data;
};
